// Get Query String Parameters
const queryString = window.location.search
const urlParams = new URLSearchParams(queryString)
const timeSlotParam = urlParams.get('timeslot')

/**
 * NEXT AVAILABLE SETUP
 * If timeslot param set and value is next, delay 500
 */
if (timeSlotParam && timeSlotParam === 'next') {
  setTimeout(() => {
    // Set custom ID on ticket selection container
    const ticketSelectionBlock = document.getElementsByClassName('tn-ticket-selector__zone-selector-container')[0]
    ticketSelectionBlock.setAttribute('id', 'custom-tickets-today')

    // Assign additional attributes to legend
    const ticketSelectionLegend = document.getElementsByClassName('tn-ticket-selector__heading-available-zones')[0]
    ticketSelectionLegend.tabIndex = 0
    ticketSelectionLegend.ariaHidden = true

    // Accordion on click functionality
    const ticketSelector = document.getElementsByClassName('tn-ticket-selector__zone-selector')[0]
    const accordionContent = ticketSelector.lastElementChild
    accordionContent.style.display = 'none'
    ticketSelectionLegend.addEventListener('click', function () {
      toggleAccordion(this, accordionContent)
    }, false)

    // Change legend text
    ticketSelectionLegend.innerText = 'CHOOSE AN ALTERNATIVE TIMESLOT'

    // Find available timeslots
    const availableTimeSlots = []
    const allTimeSlots = accordionContent.getElementsByTagName('li')
    for (const timeSlot of allTimeSlots) {
      if (!timeSlot.classList.contains('disabled')) {
        availableTimeSlots.push(timeSlot)
      }
    }

    // Select next timeslot
    const nextTimeSlot = availableTimeSlots[0]
    const nextTimeSlotLabel = nextTimeSlot.getElementsByTagName('label')[0]
    const nextTimeSlotInput = nextTimeSlotLabel.firstElementChild
    nextTimeSlotInput.click()

    // Create new element block for next timeslot
    const nextTimeSlotBlock = document.createElement('div')
    nextTimeSlotBlock.setAttribute('id', 'custom-next-time-block')
    ticketSelectionBlock.prepend(nextTimeSlotBlock)

    // Add header text
    nextTimeSlotBlock.innerHTML = '<p><strong>THE NEXT AVAILABLE ENTRY TIME IS:</strong></p>'

    // Move next timeslot
    nextTimeSlotBlock.appendChild(nextTimeSlot)

    // Handle timeslot selection
    for (const time of availableTimeSlots) {
      time.addEventListener('click', function () {
        const allOptions = document.getElementsByClassName('tn-zone-selector__option')
        for (const slot of allOptions) {
          slot.classList.remove('selected')
        }
        time.classList.add('selected')
      }, false)
    }
  }, 500)
}

/**
 * TOGGLE ACCORDION
 * @param {*} legendElement
 * @param {*} accordionContentElement
 */
function toggleAccordion (legendElement, accordionContentElement) {
  if (accordionContentElement.style.display === 'none') {
    accordionContentElement.style.display = 'flex'
    legendElement.ariaHidden = false
    legendElement.classList.add('active')
  } else {
    accordionContentElement.style.display = 'none'
    legendElement.ariaHidden = true
    legendElement.classList.remove('active')
  }
}